var _linearGradient, _polygon, _linearGradient2, _path, _linearGradient3, _circle, _linearGradient4, _rect, _linearGradient5, _rect2, _linearGradient6, _path2, _linearGradient7, _path3, _linearGradient8, _rect3, _linearGradient9, _path4, _linearGradient10, _path5, _linearGradient11, _rect4, _linearGradient12, _path6, _linearGradient13, _path7, _linearGradient14, _path8, _linearGradient15, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUniversity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G5j9QTmIclbVKQSO6bD~sa",
    x1: 24,
    x2: 24,
    y1: 5.935,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4fe5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2eb7ed"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#G5j9QTmIclbVKQSO6bD~sa)",
    points: "24,5.935 5,15 43,15"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G5j9QTmIclbVKQSO6bD~sb",
    x1: 21.476,
    x2: 25.532,
    y1: 5.577,
    y2: 20.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ea2e4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G5j9QTmIclbVKQSO6bD~sb)",
    d: "M43,16H5c-0.484,0-0.899-0.348-0.984-0.824C3.931,14.698,4.2,14.23,4.655,14.062l19-9.065 c0.223-0.082,0.469-0.082,0.691,0l19,9.065c0.455,0.168,0.724,0.637,0.639,1.114C43.899,15.652,43.484,16,43,16z M10,14h28L24,7 L10,14z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G5j9QTmIclbVKQSO6bD~sc",
    x1: 23.482,
    x2: 24.518,
    y1: 9.068,
    y2: 12.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16538c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0176d0"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 11,
    r: 2,
    fill: "url(#G5j9QTmIclbVKQSO6bD~sc)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G5j9QTmIclbVKQSO6bD~sd",
    x1: 24,
    x2: 24,
    y1: 36,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0176d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16538c"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    x: 10,
    y: 16,
    fill: "url(#G5j9QTmIclbVKQSO6bD~sd)"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G5j9QTmIclbVKQSO6bD~se",
    x1: 8.866,
    x2: 13.134,
    y1: 18.036,
    y2: 33.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ea2e4"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 16,
    x: 9,
    y: 18,
    fill: "url(#G5j9QTmIclbVKQSO6bD~se)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G5j9QTmIclbVKQSO6bD~sf",
    x1: 11,
    x2: 11,
    y1: 34,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#2fb7e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#26a5d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#1789bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#096fa1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G5j9QTmIclbVKQSO6bD~sf)",
    d: "M13,34H9c-0.552,0-1,0.448-1,1v1h6v-1C14,34.448,13.552,34,13,34z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G5j9QTmIclbVKQSO6bD~sg",
    x1: 11,
    x2: 11,
    y1: 18,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#2fb7e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#26a5d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#1789bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#096fa1"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G5j9QTmIclbVKQSO6bD~sg)",
    d: "M14,16H8v1c0,0.552,0.448,1,1,1h4c0.552,0,1-0.448,1-1V16z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G5j9QTmIclbVKQSO6bD~sh",
    x1: 34.866,
    x2: 39.134,
    y1: 18.036,
    y2: 33.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ea2e4"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 16,
    x: 35,
    y: 18,
    fill: "url(#G5j9QTmIclbVKQSO6bD~sh)"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G5j9QTmIclbVKQSO6bD~si",
    x1: 37,
    x2: 37,
    y1: 34,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#2fb7e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#26a5d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#1789bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#096fa1"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G5j9QTmIclbVKQSO6bD~si)",
    d: "M39,34h-4c-0.552,0-1,0.448-1,1v1h6v-1C40,34.448,39.552,34,39,34z"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G5j9QTmIclbVKQSO6bD~sj",
    x1: 37,
    x2: 37,
    y1: 18,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#2fb7e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#26a5d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#1789bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#096fa1"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G5j9QTmIclbVKQSO6bD~sj)",
    d: "M40,16h-6v1c0,0.552,0.448,1,1,1h4c0.552,0,1-0.448,1-1V16z"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G5j9QTmIclbVKQSO6bD~sk",
    x1: 21.866,
    x2: 26.134,
    y1: 18.036,
    y2: 33.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ea2e4"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 16,
    x: 22,
    y: 18,
    fill: "url(#G5j9QTmIclbVKQSO6bD~sk)"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G5j9QTmIclbVKQSO6bD~sl",
    x1: 24,
    x2: 24,
    y1: 34,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#2fb7e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#26a5d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#1789bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#096fa1"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G5j9QTmIclbVKQSO6bD~sl)",
    d: "M26,34h-4c-0.552,0-1,0.448-1,1v1h6v-1C27,34.448,26.552,34,26,34z"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G5j9QTmIclbVKQSO6bD~sm",
    x1: 24,
    x2: 24,
    y1: 18,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#2fb7e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#26a5d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#1789bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#096fa1"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G5j9QTmIclbVKQSO6bD~sm)",
    d: "M27,16h-6v1c0,0.552,0.448,1,1,1h4c0.552,0,1-0.448,1-1V16z"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G5j9QTmIclbVKQSO6bD~sn",
    x1: 24,
    x2: 24,
    y1: 36,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4fe5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2eb7ed"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G5j9QTmIclbVKQSO6bD~sn)",
    d: "M6,39h36v-2c0-0.552-0.448-1-1-1H7c-0.552,0-1,0.448-1,1V39z"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G5j9QTmIclbVKQSO6bD~so",
    x1: 24,
    x2: 24,
    y1: 39,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4fe5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2eb7ed"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G5j9QTmIclbVKQSO6bD~so)",
    d: "M4,42h40v-2c0-0.552-0.448-1-1-1H5c-0.552,0-1,0.448-1,1V42z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversity);
export default __webpack_public_path__ + "static/media/university.8a7aa5a02e29569a6290578eca588916.svg";
export { ForwardRef as ReactComponent };